export const schemaRelease = (props) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'description'],
      },
      {
        id: 'meeting',
        title: 'Meeting',
          fields: ['meetDomain', 'meetRoom','meetUser', 'meetAppId', 'meetJWT'],
      },
    ],
    properties: {
      title: {
        title: 'Title',
        widget: 'text',
      },
      description: {
        title: 'Description',
        widget: 'text',
      },
      meetDomain: {
        title: 'Domain',
        widget: 'text',
      },
      meetRoom: {
        title: 'Room',
        widget: 'text',
      },
      meetUser: {
        title: 'User',
        widget: 'text',
      },
      meetAppId: {
        title: 'appId',
        widget: 'text',
      },
      meetJWT: {
        title: 'jwt',
        widget: 'text',
      },
    },
  };
};

export default schemaRelease;
